import { render, staticRenderFns } from "./productCardSearch.vue?vue&type=template&id=1db62156&scoped=true&"
import script from "./productCardSearch.vue?vue&type=script&lang=js&"
export * from "./productCardSearch.vue?vue&type=script&lang=js&"
import style0 from "./productCardSearch.vue?vue&type=style&index=0&id=1db62156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db62156",
  null
  
)

export default component.exports